module.exports = __webpack_public_path__ + "img/ic_bolt_white_24dp.3bcba6be.png";